export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
}

export interface ServiceConfig {
  name: string;
  appScheme: string;
  web: string;
  logo: string;
  description: string;
  appStore: string;
  playStore: string;
  callPagePath: string; // deeplink path name to the call page in the app
}

export interface AppConfig {
  ENVIRONMENT: string;
  DEBUG: boolean;
  FIREBASE_CONFIG: FirebaseConfig;
  SERVICES: {
    vis: ServiceConfig;
    sls: ServiceConfig;
  };
}

const CONFIG_MAP: Record<string, AppConfig> = {
  development: {
    ENVIRONMENT: 'development',
    DEBUG: true,
    FIREBASE_CONFIG: {
      apiKey: 'AIzaSyB9GHg-0-8Aq-3MRo4ppq4H6PCKzZcNhxo',
      authDomain: 'aira-dev-explorer.firebaseapp.com',
      projectId: 'aira-dev-explorer',
      storageBucket: 'aira-dev-explorer.firebasestorage.app',
      messagingSenderId: '1000385673999',
      appId: '1:1000385673999:web:e140d67f379bdfe2639c7a',
      measurementId: 'G-6JSYET4DDG',
    },
    SERVICES: {
      vis: {
        name: 'Visual Interpreting',
        logo: '/images/aira_explorer_icon.svg',
        description: 'On-demand visual interpreting for the blind and low vision community.',
        appScheme: 'https://dev-link.aira.io',
        web: 'https://explorer-dev.aira.io',
        appStore: 'https://apps.apple.com/app/aira-explorer/id1590186766',
        playStore: 'https://play.google.com/store/apps/details?id=io.aira.explorer',
        callPagePath: 'session',
      },
      sls: {
        name: 'ASL Interpreting',
        logo: '/images/aira_asl_icon.svg',
        description:
          'On-demand American Sign Language interpreting for Deaf and hard-of-hearing community.',
        appScheme: 'https://dev-asl.link.aira.io',
        web: 'https://asl-dev.aira.io',
        appStore: 'https://apps.apple.com/app/aira-asl/id6547831901',
        playStore: 'https://play.google.com/store/apps/details?id=io.aira.asl',
        callPagePath: 'session',
      },
    },
  },

  production: {
    ENVIRONMENT: 'production',
    DEBUG: false,
    FIREBASE_CONFIG: {
      apiKey: 'AIzaSyDwE5F6G7H8I9J0K1L2M3N4O5P6Q7R8S9T0',
      authDomain: 'aira-prod-explorer.firebaseapp.com',
      projectId: 'aira-prod-explorer',
      storageBucket: 'aira-prod-explorer.firebasestorage.app',
      messagingSenderId: '2000385673999',
      appId: '1:2000385673999:web:f250e78g489cefe3749d8b',
      measurementId: 'G-DNGEWSWFFM',
    },
    SERVICES: {
      vis: {
        name: 'Visual Interpreting',
        logo: '/images/aira_explorer_icon.svg',
        description: 'On-demand visual interpreting for the blind and low vision community.',
        appScheme: 'https://link.aira.io',
        web: 'https://explorer.aira.io',
        appStore: 'https://apps.apple.com/app/aira-explorer/id1590186766',
        playStore: 'https://play.google.com/store/apps/details?id=io.aira.explorer',
        callPagePath: 'session',
      },
      sls: {
        name: 'ASL Interpreting',
        logo: '/images/aira_asl_icon.svg',
        description:
          'On-demand American Sign Language interpreting for Deaf and hard-of-hearing community.',
        appScheme: 'https://asl.link.aira.io',
        web: 'https://asl.aira.io',
        appStore: 'https://apps.apple.com/app/aira-asl/id6547831901',
        playStore: 'https://play.google.com/store/apps/details?id=io.aira.asl',
        callPagePath: 'session',
      },
    },
  },
};

export function getConfig(): AppConfig {
  const environment = import.meta.env.MODE || 'development';
  return CONFIG_MAP[environment] || CONFIG_MAP.development;
}
